// AUTO-GENERATED by scripts/gen-odata-hooks.cjs — do not edit.
// One typed shim per -odata GET, over the single useODataQuery core.
// Regenerate with: yarn gen-odata-hooks
import {
    useODataQuery,
    type ODataQueryOptions,
    type ODataServerArgs,
} from "@/hooks/use-odata-query";
import type {
    AlertDto,
    ChargerMeterValue,
    DeviceCatalogueDto,
    DeviceDto,
    DeviceGroupDto,
    DeviceInvitationDto,
    DeviceMaintenanceStatusLogDto,
    DeviceOwnerDto,
    LogMessageOutputModel,
    OfferDto,
    OnlineStatusItem,
    PaymentLogDto,
    RfidTagDto,
    ServiceEventDto,
    StatusItem,
    Transaction,
    UserAccountDto,
    UserActionLogDto,
    VehicleModelReferenceDto,
    WebhookDto,
} from "@/api/openapi";

export const useAlertListODataServer = (
    args: ODataServerArgs = {},
    queryOptions?: ODataQueryOptions<AlertDto>,
) => useODataQuery<AlertDto>("/alerts-odata", args, queryOptions);

export const useChargerMeterValuesODataServer = (
    transactionId: string | number,
    args: ODataServerArgs = {},
    queryOptions?: ODataQueryOptions<ChargerMeterValue>,
) =>
    useODataQuery<ChargerMeterValue>(
        `/transactions/${transactionId}/charger-meter-values-odata`,
        args,
        queryOptions,
    );

export const useDeviceCatalogueODataServer = (
    args: ODataServerArgs = {},
    queryOptions?: ODataQueryOptions<DeviceCatalogueDto>,
) =>
    useODataQuery<DeviceCatalogueDto>(
        "/device-catalogue-odata",
        args,
        queryOptions,
    );

export const useDeviceGroupsODataServer = (
    args: ODataServerArgs = {},
    queryOptions?: ODataQueryOptions<DeviceGroupDto>,
) => useODataQuery<DeviceGroupDto>("/device-groups-odata", args, queryOptions);

export const useDeviceInvitationsODataServer = (
    args: ODataServerArgs = {},
    queryOptions?: ODataQueryOptions<DeviceInvitationDto>,
) =>
    useODataQuery<DeviceInvitationDto>(
        "/deviceinvitations-odata",
        args,
        queryOptions,
    );

export const useDeviceListForGroupAssignmentODataServer = (
    deviceGroupTag: string | number,
    args: ODataServerArgs = {},
    queryOptions?: ODataQueryOptions<DeviceDto>,
) =>
    useODataQuery<DeviceDto>(
        `/device-groups/${deviceGroupTag}/devices-for-assignment-odata`,
        args,
        queryOptions,
    );

export const useDeviceListODataServer = (
    args: ODataServerArgs = {},
    queryOptions?: ODataQueryOptions<DeviceDto>,
) => useODataQuery<DeviceDto>("/devices-odata", args, queryOptions);

export const useDeviceMaintenanceStatusLogsOdataServer = (
    deviceIdentity: string | number,
    args: ODataServerArgs = {},
    queryOptions?: ODataQueryOptions<DeviceMaintenanceStatusLogDto>,
) =>
    useODataQuery<DeviceMaintenanceStatusLogDto>(
        `/devices/${deviceIdentity}/maintenance-status-odata`,
        args,
        queryOptions,
    );

export const useDeviceOwnersODataServer = (
    args: ODataServerArgs = {},
    queryOptions?: ODataQueryOptions<DeviceOwnerDto>,
) => useODataQuery<DeviceOwnerDto>("/deviceowners-odata", args, queryOptions);

export const useGetDeviceLogMessagesServer = (
    deviceIdentity: string | number,
    args: ODataServerArgs = {},
    queryOptions?: ODataQueryOptions<LogMessageOutputModel>,
) =>
    useODataQuery<LogMessageOutputModel>(
        `/devices/${deviceIdentity}/log-messages-odata`,
        args,
        queryOptions,
    );

export const useGetImpactedTransactionsODataServer = (
    alertId: string | number,
    args: ODataServerArgs = {},
    queryOptions?: ODataQueryOptions<Transaction>,
) =>
    useODataQuery<Transaction>(
        `/alerts/${alertId}/impacted-transactions-odata`,
        args,
        queryOptions,
    );

export const useGetServiceEventsODataServer = (
    args: ODataServerArgs = {},
    queryOptions?: ODataQueryOptions<ServiceEventDto>,
) =>
    useODataQuery<ServiceEventDto>("/service-events-odata", args, queryOptions);

export const useOffersODataServer = (
    args: ODataServerArgs = {},
    queryOptions?: ODataQueryOptions<OfferDto>,
) => useODataQuery<OfferDto>("/offers-odata", args, queryOptions);

export const useOnlineStatusLogsODataServer = (
    deviceIdentity: string | number,
    args: ODataServerArgs = {},
    queryOptions?: ODataQueryOptions<OnlineStatusItem>,
) =>
    useODataQuery<OnlineStatusItem>(
        `/devices/${deviceIdentity}/online-status-logs-odata`,
        args,
        queryOptions,
    );

export const usePaymentLogsODataServer = (
    args: ODataServerArgs = {},
    queryOptions?: ODataQueryOptions<PaymentLogDto>,
) => useODataQuery<PaymentLogDto>("/payment-logs-odata", args, queryOptions);

export const useRfidTagsOdataServer = (
    args: ODataServerArgs = {},
    queryOptions?: ODataQueryOptions<RfidTagDto>,
) => useODataQuery<RfidTagDto>("/rfidtags-odata", args, queryOptions);

export const useStatusLogsODataServer = (
    deviceIdentity: string | number,
    args: ODataServerArgs = {},
    queryOptions?: ODataQueryOptions<StatusItem>,
) =>
    useODataQuery<StatusItem>(
        `/devices/${deviceIdentity}/status-logs-odata`,
        args,
        queryOptions,
    );

export const useTransactionsByDeviceODataServer = (
    deviceIdentity: string | number,
    args: ODataServerArgs = {},
    queryOptions?: ODataQueryOptions<Transaction>,
) =>
    useODataQuery<Transaction>(
        `/devices/${deviceIdentity}/transactions-odata`,
        args,
        queryOptions,
    );

export const useTransactionsODataServer = (
    args: ODataServerArgs = {},
    queryOptions?: ODataQueryOptions<Transaction>,
) =>
    useODataQuery<Transaction>(
        "/transactions/transactions-odata",
        args,
        queryOptions,
    );

export const useUptimeDeviceListODataServer = (
    args: ODataServerArgs = {},
    queryOptions?: ODataQueryOptions<DeviceDto>,
) => useODataQuery<DeviceDto>("/uptime-devices-odata", args, queryOptions);

export const useUserAccountsODataServer = (
    args: ODataServerArgs = {},
    queryOptions?: ODataQueryOptions<UserAccountDto>,
) => useODataQuery<UserAccountDto>("/user-accounts-odata", args, queryOptions);

export const useUserActionLogsODataServer = (
    args: ODataServerArgs = {},
    queryOptions?: ODataQueryOptions<UserActionLogDto>,
) =>
    useODataQuery<UserActionLogDto>(
        "/user-action-logs-odata",
        args,
        queryOptions,
    );

export const useVehicleModelReferencesODataServer = (
    args: ODataServerArgs = {},
    queryOptions?: ODataQueryOptions<VehicleModelReferenceDto>,
) =>
    useODataQuery<VehicleModelReferenceDto>(
        "/vehicle-model-references-odata",
        args,
        queryOptions,
    );

export const useWebhooksListOdataServer = (
    args: ODataServerArgs = {},
    queryOptions?: ODataQueryOptions<WebhookDto>,
) => useODataQuery<WebhookDto>("/webhooks-odata", args, queryOptions);
